export default __webpack_public_path__ + "static/media/nadja-hadad.9586695c.jpg";